import type { PaigeClient } from '@paige/api-client';
import type { AdminApi } from './data-source';
import type {
  AdminDesktopGpus,
  AdminGpuCards,
  DesktopPolicyAnswer,
  DesktopPolicyState,
} from './types';
import { unwrap } from './http';

/** The GPU reads and writes (`/admin/gpu-cards`, `/admin/desktop-gpus`): which card does what, names, cards and schedule. */
export function gpuApi(
  client: PaigeClient,
): Pick<
  AdminApi,
  | 'getGpuCards'
  | 'getDesktopGpus'
  | 'nameDesktopGpu'
  | 'getDesktopGpuPolicy'
  | 'setDesktopGpuPolicy'
> {
  return {
    async getGpuCards() {
      return unwrap(await client.GET('/admin/gpu-cards')) as AdminGpuCards;
    },
    async getDesktopGpus() {
      return unwrap(await client.GET('/admin/desktop-gpus')) as AdminDesktopGpus;
    },
    async nameDesktopGpu(worker, name) {
      unwrap(
        await client.PUT('/admin/desktop-gpus/{worker}/name', {
          params: { path: { worker } },
          body: { name },
        }),
      );
    },
    async getDesktopGpuPolicy(machine) {
      return unwrap(
        await client.GET('/admin/desktop-gpus/{machine}/policy', { params: { path: { machine } } }),
      ) as DesktopPolicyState;
    },
    async setDesktopGpuPolicy(machine, body) {
      return unwrap(
        await client.PUT('/admin/desktop-gpus/{machine}/policy', {
          params: { path: { machine } },
          body,
        }),
      ) as DesktopPolicyAnswer;
    },
  };
}
